import { render, staticRenderFns } from "./ShowResponsibility.vue?vue&type=template&id=56d7d104&"
import script from "./ShowResponsibility.vue?vue&type=script&lang=js&"
export * from "./ShowResponsibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports